import { CmStreamType } from '@svta/cml-cta'

/**
 * Common Media Server Data Stream Type
 *
 *
 * @enum
 *
 * @beta
 */
export const CmsdStreamType = CmStreamType as typeof CmStreamType

/**
 * @beta
 */
export type CmsdStreamType = CmStreamType;
